import { ReactNode } from "react";
import styles from "./main.module.css";
import { useSidebarToggle } from "context/ToggleSideBarContext";

export default function Main({ children }: { children: ReactNode }) {
  const { isSideBarOpen } = useSidebarToggle();
  return (
    <main
      className={`${styles.main} ${isSideBarOpen ? styles["sidebar-open"] : styles["sidebar-close"]}`}
    >
      {children}
    </main>
  );
}
